"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            borderColor: 'transparent',
            '& .InovuaReactDataGrid__header': {
                fontSize: '12px',
                textTransform: 'uppercase',
                color: themes_1.materialColors.grey[500],
                fontWeight: 'bold',
            },
            '& .InovuaReactDataGrid__row-active-borders > *': {
                borderColor: themes_1.materialColors.yellow[100],
            },
            '& .InovuaReactDataGrid__row--active > *': {
                background: themes_1.materialColors.yellow[50],
            },
            '& .InovuaReactDataGrid__row--selected > *': {
                background: themes_1.materialColors.yellow[50],
            },
            // indeterminate checkbox colors 
            '& .inovua-react-toolkit-checkbox--indeterminate .inovua-react-toolkit-checkbox__icon-wrapper svg': {
                backgroundColor: "".concat(themes_1.materialColors.blue[500], " !important"), // background instead of fill
            },
            // checked checkbox colors
            '& .inovua-react-toolkit-checkbox--checked .inovua-react-toolkit-checkbox__icon-wrapper': {
                fill: "".concat(themes_1.materialColors.blue[500], " !important"),
            },
        },
        row: {
            // NOTE: change this for zebra stripe styles
            // '&.InovuaReactDataGrid__row--odd': {
            //   backgroundColor: materialColors.blue[50]
            // },
            '&:hover': {
                background: themes_1.materialColors.yellow[50],
            },
            '&:hover .InovuaReactDataGrid__cell': {
                background: themes_1.materialColors.yellow[50],
            },
        },
    });
});
